import { callUIAPI } from "../utils/apiUtils";
import { METHOD_GET } from "../utils/apiUtilsConstants";

export const getQuestionAnswers = async (entityName, typeId, recordId) => {
  const input = {entityName, typeId, recordId};
  console.log('QuestionAnswerDAO.getQuestionAnswers - input:', input);
  return callUIAPI('answers', input, METHOD_GET, true)
  .then(response => {
    return response.data.list;
  })
}

